import { qualityImgUrl } from '../../utils/util'
export default {
    name: 'qualityImg',
    data () {
        return {
            qualitySrc: '',
            qualityActSrc: '',
        }
    },
    props: {
        src: { // 正常的显示
            required: true,
            type: String
        },
        actSrc: { // 活动的图片
            required: false,
            type: String,
            default: ''
        },
        width:{
            required: true,
        },
        height:{
            required: true,
        },
        contrast:{
            required: false,
            default: 'q'
        },
        percentage:{
            required: false,
            default: 100
        }
    },
    watch: {
        src (newValue, oldValue) {
            this.qualitySrc = qualityImgUrl(newValue, {
                width: Number(this.width),
                height: Number(this.height),
                contrast: String(this.contrast),
                percentage: Number(this.percentage),
            })
        },
        actSrc (newValue, oldValue) {
            if (newValue) {
                this.qualityActSrc = qualityImgUrl(newValue, {
                    width: Number(this.width),
                    height: Number(this.height),
                    contrast: String(this.contrast),
                    percentage: Number(this.percentage),
                })
            } else {
                // 切换规格的时候，有些规格是没有标签图
                this.qualityActSrc = ''
            }
        }
    },
    mounted () {
        this.common()
    },
    beforeUpdate () {
        this.common()
    },
    methods: {
        common () {
            let src = this.src
            if (src === '') {
                src = 'https://image.carisok.com/images/service_default.png'
            }
            this.qualitySrc = qualityImgUrl(src, {
                width: Number(this.width),
                height: Number(this.height),
                contrast: String(this.contrast),
                percentage: Number(this.percentage),
            })
            if (!this.actSrc) return
            this.qualityActSrc = qualityImgUrl(this.actSrc, {
                width: Number(this.width),
                height: Number(this.height),
                contrast: String(this.contrast),
                percentage: Number(this.percentage),
            })
        }
    },
}
